const STORAGE_KEY = 'filtros_busca_imobiliario';

export function getFiltrosSafe(): any[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];

    let parsed: any = raw;

    let attempts = 0;
    while ((typeof parsed === 'string' || parsed === null) && attempts < 5) {
      const trimmed = String(parsed).trim();
      if (trimmed === '' || trimmed === 'null') return [];

      if (/^["\[{]/.test(trimmed)) {
        try {
          parsed = JSON.parse(trimmed);
        } catch (err) {
          return [];
        }
      } else {
        break;
      }
      attempts++;
    }

    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    return [];
  }
}

export function setFiltrosSafe(filtros: any[]): void {
  try {
    let toSave = filtros;
    if (typeof filtros === 'string') {
      try {
        toSave = JSON.parse(filtros);
      } catch {
        return;
      }
    }

    if (!Array.isArray(toSave)) {
      return;
    }

    const unique = Array.from(
      new Set(toSave.map((f: any) => JSON.stringify(f))),
    ).map((s) => JSON.parse(s));

    localStorage.setItem(STORAGE_KEY, JSON.stringify(unique));
  } catch (err) {
    console.warn('[FiltroImobiliario] Erro ao salvar localStorage:', err);
  }
}
